<template>
  <div class="vx-row">
    <div class="w-full vx-col">
        <vx-card  titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters" :collapse-action="true">
            <div class="vx-row">
                <div class="w-full vx-col md:w-1/3 sm:w-1/2">
                    <label class="text-sm opacity-100 text-bold">Name</label>
                    <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="w-full mb-4 md:mb-0"/>
                </div>
            </div>
            <div class="mt-5 vx-row">
                <div class="w-full ml-auto vx-col">
                    <vs-button class="float-right mr-4" size="small"
                                color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
      <vx-card :title="'CRM CONTACT SUBJECTS'" class="">
        <template slot="actions">
          <vs-button v-can="'edit-communication-subjects-setting'" @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4"  color="primary" type="filled">create</vs-button>
        </template>
        <div id="subjets-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="crm_subjects">
              <template slot="thead">
                <vs-th width="75%">Name</vs-th>
                <vs-th width="25%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row" v-can="'edit-communication-subjects-setting'">
                      <vx-tooltip text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <AddNewCrmSubjectsPopUp ref="addNewCrmSubjectsPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import {defaultPagination, perPageList} from "@/constants/config";
  import AddNewCrmSubjectsPopUp from '@/components/popups/settings/crm-subjects/AddNewCrmSubjectsPopUp.vue';

  const CrmRepository = RepositoryFactory.get('crm');
  export default {
    name: "CustomerCrmSubjectSettings",
    data() {
      return {
        crm_subjects: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
    AddNewCrmSubjectsPopUp
},
    methods: {
      async refreshData() {
        await this.fetchCrmSubjects()
      },
      async fetchCrmSubjects() {
        await this.$vs.loading({
          container: '#subjets-table',
          scale: 0.45
        })
        const {data} = (await CrmRepository.getListOfSubjects(this.page, this.filterQuery, this.perPage, this.sort)).data
        this.crm_subjects =  data.data
        this.meta.total = data.total
        this.meta.last_page = data.last_page
        this.meta.per_page = data.per_page
        this.$vs.loading.close('#subjets-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.addNewCrmSubjectsPopUp.openPopup()
      },
      async onClickUpdate(id) {
        await this.$refs.addNewCrmSubjectsPopUp.openPopup(id)
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      async onClickDelete(params) {
        try {
          await CrmRepository.deleteCrmSubject(params[0])
          await this.fetchCrmSubjects()
          await this.showSuccessMessage('Subject Deleted!');
        }catch (e) {
            this.convertAndNotifyError(e)
        }
      },
      filterQueryUpdate (){
        this.fetchCrmSubjects()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchCrmSubjects()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchCrmSubjects()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    async mounted() {
      await this.fetchCrmSubjects()
    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchCrmSubjects()
      },
      perPage() {
        this.fetchCrmSubjects()
      }
    }
  }
</script>

<style scoped>

</style>
